export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 12c4.065 0 7.5 3.06 7.5 7a1 1 0 01-1 1h-6v-2h4.888c-.505-2.237-2.668-4-5.388-4h-3.751C14.13 15.26 15 17.018 15 19a1 1 0 01-1 1H1a1 1 0 01-1-1c0-3.94 3.435-7 7.5-7h9zm-9 2c-2.72 0-4.883 1.763-5.388 4h10.776c-.505-2.237-2.668-4-5.388-4zM7.5 4a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2zM16.5 4a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};